import React, { useEffect } from 'react';
import {
  CardHeader, Divider, MenuItem, Grid,
  InputLabel, TextField, Box, Button
} from '@material-ui/core';
import { Formik } from 'formik';
import * as Yup from "yup";

export default function WitheredLeaf({ handleNext, witheringDetails, setWitheringDetails, manufacturingDetail, StatusID, firingDetails, rollingDetails, setRollingDetails, isUpdate }) {
  useEffect(() => {
    setWitheringDetails((prevState) => ({
      ...prevState,
      witheredLeafPercentage: manufacturingDetail.greenLeafAmount == 0 ? 0 : parseFloat((witheringDetails.witheredLeafAmount / manufacturingDetail.greenLeafAmount ) * 100).toFixed(1)
    }));
  }, [witheringDetails.witheredLeafAmount]);
  useEffect(() => {
    if (new Date(witheringDetails.endDate) <= new Date(witheringDetails.startDate)) {
      const newEndDate = new Date(witheringDetails.startDate);
      const formattedEndDate = formatDateTime(newEndDate);
      setWitheringDetails((prevState) => ({
        ...prevState,
        endDate: formattedEndDate
      }));
    }
  }, [witheringDetails.startDate]);

  function formatDateToLocal(date) {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().slice(0, 16);
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value

    if (e.target.name != "witheredLeafAmount") {
      setWitheringDetails({
        ...witheringDetails,
        [e.target.name]: value
      });
    }
    else {
      const finalValue = value == "" ? parseFloat(0) : value
      var reg = new RegExp('^[0-9]{0,9}([.]?[0-9]{0,2})?$');
      if (reg.test(finalValue) == false) {
        return;
      }
      setWitheringDetails({
        ...witheringDetails,
        [e.target.name]: finalValue == "" ? parseFloat(0) : parseFloat(finalValue)
      });
    }
  }

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  const formatDateTime = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const shouldShowWitheredLeafPercentage = parseFloat(firingDetails.totalFireWeight) > 0;

  return (
    <>
      <Formik
        initialValues={{
          startDate: witheringDetails.startDate,
          endDate: witheringDetails.endDate,
          witheredLeafAmount: witheringDetails.witheredLeafAmount,
          witheringCondition: witheringDetails.witheringCondition
        }}
        validationSchema={
          Yup.object().shape({
            startDate: Yup.string().required('Start Date is required').typeError('Invalid date'),
            endDate: Yup.string().required('End Date is required').typeError('Invalid date'),
            witheredLeafAmount: Yup.number().required('Withered Leaf is required').min(0.01, 'Withered Leaf should be grater than 0')
              .max(manufacturingDetail.greenLeafAmount, "Withered Leaf should be less than Green Leaf Quantity"),
            witheringCondition: Yup.number().required('Withering Condition is required').min("1", 'Withering Condition is required')

          })
        }
        enableReinitialize
      >
        {({
          errors,
          handleBlur,
          handleSubmit,
          touched,
          setTouched,
          validateForm
        }) => (
          <form onSubmit={handleSubmit}>
            <>
              <CardHeader title={"Withered Leaf"} />
              <Divider />
              &nbsp;
              <Grid container spacing={3}>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="startDate">
                    Start Date & Time *
                  </InputLabel>
                  <TextField
                    fullWidth
                    name="startDate"
                    type="datetime-local"
                    error={Boolean(touched.startDate && errors.startDate)}
                    helperText={touched.startDate && errors.startDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    value={witheringDetails.startDate}
                    variant="outlined"
                    id="startDate"
                    size='small'
                    onKeyDown={onKeyDown}
                    inputProps={{
                      min: formatDateTime(manufacturingDetail.fromDateOfManufacture),
                      max: formatDateTime(manufacturingDetail.toDateOfManufacture)
                    }}
                    InputProps={{
                      readOnly: StatusID == 2 || StatusID == 3
                    }}
                  >
                  </TextField>
                </Grid>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="endDate">
                    End Date & Time *
                  </InputLabel>
                  <TextField
                    fullWidth
                    type="datetime-local"
                    error={Boolean(touched.endDate && errors.endDate)}
                    helperText={touched.endDate && errors.endDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="endDate"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    value={witheringDetails.endDate}
                    variant="outlined"
                    id="endDate"
                    size='small'
                    inputProps={{
                      min: witheringDetails.startDate,
                      max: formatDateTime(manufacturingDetail.toDateOfManufacture)
                    }}
                    onKeyDown={onKeyDown}
                    InputProps={{
                      readOnly: StatusID == 2 || StatusID == 3
                    }}
                  >
                  </TextField>
                </Grid>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="witheredLeafAmount">
                    Withered Leaf (KG) *
                  </InputLabel>
                  <TextField
                    fullWidth
                    error={Boolean(touched.witheredLeafAmount && errors.witheredLeafAmount)}
                    helperText={touched.witheredLeafAmount && errors.witheredLeafAmount}
                    name="witheredLeafAmount"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    value={witheringDetails.witheredLeafAmount}
                    variant="outlined"
                    id="witheredLeafAmount"
                    size='small'
                    InputProps={{
                      readOnly: StatusID == 2 || StatusID == 3,
                      inputProps: {
                        step: 0.01,
                        type: 'number',
                        style: {
                          textAlign: 'right',
                        },
                      },
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "-") && evt.preventDefault()
                    }
                    onWheel={event => event.target.blur()}
                  />
                </Grid>
                {shouldShowWitheredLeafPercentage && (
                  <Grid item md={3} xs={8}>
                    <InputLabel shrink id="witheredLeafPercentage">
                      Withered Leaf (%)
                    </InputLabel>
                    <TextField
                      fullWidth
                      error={Boolean(touched.witheredLeafPercentage && errors.witheredLeafPercentage)}
                      helperText={touched.witheredLeafPercentage && errors.witheredLeafPercentage}
                      name="witheredLeafPercentage"
                      onBlur={handleBlur}
                      onChange={(e) => handleChange(e)}
                      value={witheringDetails.witheredLeafPercentage === 0 || witheringDetails.witheredLeafPercentage === undefined ? "" : witheringDetails.witheredLeafPercentage}
                      variant="outlined"
                      id="witheredLeafPercentage"
                      size='small'
                      InputProps={{
                        readOnly: true,
                        inputProps: {
                          step: 0.01,
                          type: 'number',
                          style: {
                            textAlign: 'right',
                          },
                        },
                      }}
                      onKeyDown={(evt) =>
                        (evt.key === "-") && evt.preventDefault()
                      }
                      onWheel={event => event.target.blur()}
                    />
                  </Grid>
                )}
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="witheringCondition">
                    Withering Condition *
                  </InputLabel>
                  <TextField select
                    fullWidth
                    error={Boolean(touched.witheringCondition && errors.witheringCondition)}
                    helperText={touched.witheringCondition && errors.witheringCondition}
                    name="witheringCondition"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    value={witheringDetails.witheringCondition}
                    variant="outlined"
                    id="witheringCondition"
                    size='small'
                    InputProps={{
                      readOnly: StatusID == 2 || StatusID == 3
                    }}
                  >
                    <MenuItem value="0">--Select Withering Condition--</MenuItem>
                    <MenuItem value="1">Soft</MenuItem>
                    <MenuItem value="2">Medium</MenuItem>
                    <MenuItem value="3">Hard</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
              &nbsp;
              <Box display="flex" justifyContent="flex-end">
                <Button
                  color="primary"
                  variant="contained"
                  type='button'
                  size='small'
                  onClick={async () => {
                    await setTouched({
                      startDate: true,
                      endDate: true,
                      witheredLeafAmount: true,
                      witheringCondition: true
                    });
                    const formErrors = await validateForm();
                    if (Object.keys(formErrors).length === 0) {
                      handleNext();
                    }
                  }}
                >
                  Next
                </Button>
              </Box>
            </>
          </form>
        )}
      </Formik>
    </>
  )
}